import React, { useState, useRef, useEffect, useCallback } from 'react';
// import { useTranslation } from "react-i18next";
import Table from 'react-bootstrap/Table';
import Modal from 'react-bootstrap/Modal';
import { motion } from "framer-motion";
// import "./index.scss";

import Pagination from "../../../../../components/ui/Pagination";
import NoDataFound from "../../../../../components/ui/NoDataFound";
// import CustomToolTip from "../../../../../components/ui/Tooltip";
// import Button from "../../../../../components/ui/Button";
// import RadioButton from "../../../../../components/ui/RadioButton";
// import { toaster } from "../../../../../components/ui/Toaster";
import SkeletonLoader from "../../../../../components/ui/SkeletonLoader";

import { useScanInfoContext } from "../../../../ScanInfo/ScanInfoContext";

import { searchIcon, showScreenshotIcon } from "../../../../../utils/icons";
import { formatDate } from "../../../../../utils/util";

import EndpointsFilter from "../../../../../components/PostLogin/ScanInfo/ExposureManagement/ConcerningExposure/EndpointFilter";

// import apiEndpoints from "../../../../../apiEndpoints";

import { useSelector, useDispatch } from 'react-redux';
import { getRansomweregroupData } from "../../../../../store/actions/thirdPartyRiskAction";

const ThirdPartyRansomewareGroupLeaks = () => {

    const ransomwereGroupDataResponse = useSelector((state) => state.thirdPartyRisk?.ransomwereGroupData);
    // const updateStatusListResponse = useSelector((state) => state?.scanInfo?.updateStatusList);

    const prevDomainIdRef = useRef(null);
    const prevScanIdRef = useRef(null);
    // const viewMoreWrapperRef = useRef(null);
    const filterWrapperRef = useRef(null);

    // const updateUrl = apiEndpoints.scanInfo.exposureManagemnet.concerningExposure.gitLeaks

    const dispatch = useDispatch();

    const { domainId, scanId, organizationId } = useScanInfoContext();

    const [searchValue, setSearchValue] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [isSearchFocused, setIsSearchFocused] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState(10);
    const [isLoading, setIsLoading] = useState(false);
    const [scanNotFound, setScanNotFound] = useState(false);
    const [screenShotSrc, setScreenShotSrc] = useState("");
    const [showScreenshotModal, setShowScreenshotModal] = useState(false);
    // const [gitLeaksList, setGitLeaksList] = useState(null);
    // modal state
    // const [showActionModal, setShowActionModal] = useState(false);
    // const [modalType, setModalType] = useState("")
    // const [selectedData, setSelectedData] = useState("");
    // const [modalLoading, setModalLoading] = useState(false);
    // const [showViewMore, setShowViewMore] = useState(false);
    // const [selectedValid, setSelectedValid] = useState("");
    // const [selectedStatus, setSelectedStatus] = useState("");

    //filter value
    const [showFilter, setShowFilter] = useState(false);
    

    //selected filter value
    const [endpointFiltersValue, setEndpointFiltersValue] = useState({})
    

    const setCurrentPageandRecordSize = (currentPage, pageSize) => {
        setCurrentPage(currentPage);
        if(pageSize !== currentPageSize) {
            setCurrentPageSize(pageSize);
            setCurrentPage(1);
        }
    }

    const handleSearchKeyDown = (event) => {
        if (event.key === "Enter" && isSearchFocused) {
            onSearch()
        }
    }

    const onSearch = () => {
        setCurrentPage(1)
        setSearchQuery(searchValue)
    }

    const endPointFilterApply = (data) => {
        setEndpointFiltersValue(data)
    }

    const isAnyEndpointFilterActive = Object.values(endpointFiltersValue).some(value => Boolean(value));

    const resetEndpointFilterValue = () => {
        setCurrentPage(1)
        setEndpointFiltersValue({})
    }

    const fetchdData = useCallback(()=>{
        setIsLoading(true)
        const baseUrl = `&page=${currentPage}&page_size=${currentPageSize}`;
        const params = organizationId.toLowerCase() !== "all" && domainId.toLowerCase() === "all" ? `&organization_id=${organizationId}`: `&domain=${domainId}&scan_id=${scanId}`
        const queryParams = searchQuery ? `&query=${searchQuery}` : "";
        const newFindings = endpointFiltersValue?.newFindings?.value && endpointFiltersValue?.newFindings?.value !== "all" ? `&new_record=${endpointFiltersValue?.newFindings?.value === "yes" ? true : false}` : "";
        const url = `${baseUrl}${params}${queryParams}${newFindings}`
        dispatch(getRansomweregroupData(url))
    },[dispatch, currentPage, currentPageSize, organizationId, domainId, scanId, searchQuery, endpointFiltersValue])

    // const confirmDelete = () => {
    //     setModalLoading(true)
    //     let obj = {
    //         domain: selectedData?.domain,
    //         scan_id: selectedData?.scan_id,
    //         result_id: selectedData?.id
    //     }
    //     dispatch(updateListData(updateUrl.gitLeakDelete(), obj))
    // }

    // const saveUpdate = () => {
    //     setModalLoading(true)
    //     let obj = {
    //         domain: selectedData?.domain,
    //         scan_id: selectedData?.scan_id,
    //         result_id: selectedData?.id,
    //         false_positive: selectedValid === "valid" ? false : true
    //     }
    //     dispatch(updateListData(updateUrl.gitLeakValidate(), obj))
    // }

    // const updateStatus = () => {
    //     setModalLoading(true)
    //     let obj = {
    //         domain: selectedData?.domain,
    //         scan_id: selectedData?.scan_id,
    //         result_id: selectedData?.id,
    //         status: selectedStatus
    //     }
    //     dispatch(updateListData(updateUrl.gitLeakStatus(), obj))
    // }

    // const updateRetest = () => {
    //     setModalLoading(true)
    //     let obj = {
    //         domain: selectedData?.domain,
    //         scan_id: selectedData?.scan_id,
    //         result_id: selectedData?.id
    //     }
    //     if(modalType === "start") {
    //         dispatch(updateListData(updateUrl.gitLeakStart(), obj))
    //     } else {
    //         dispatch(updateListData(updateUrl.gitLeakStop(), obj))
    //     }
    // }

    useEffect(()=>{
        fetchdData()
    },[currentPage, fetchdData])

    useEffect(()=>{
        if(domainId !== prevDomainIdRef.current || scanId !== prevScanIdRef.current) {
            setCurrentPage(1);
            prevDomainIdRef.current = domainId;
            prevScanIdRef.current = scanId;
        }
    },[domainId, scanId]);

    useEffect(()=>{
        if(ransomwereGroupDataResponse !== null) {
            if(ransomwereGroupDataResponse?.status === "failed") {
                setScanNotFound(true)
            } else {
                setScanNotFound(false)
            }
            setIsLoading(false)
        }
    },[ransomwereGroupDataResponse])

    // useEffect(()=>{
    //     if(updateStatusListResponse !== null) {
    //         setShowActionModal(false)
    //         setModalLoading(false)
    //         if(updateStatusListResponse?.status === "success") {
    //             toaster.addToast(updateStatusListResponse?.description,"success")
    //             fetchdData()
    //         } else {
    //             toaster.addToast(updateStatusListResponse?.description,"error")
    //         }
    //         dispatch(resetUpdateListDataResponse())
    //     }
    // },[updateStatusListResponse, fetchdData, dispatch])

    // useEffect(()=>{
    //     document.addEventListener("mousedown", handleClickOutside);

    //     function handleClickOutside(event) {
    //         if (viewMoreWrapperRef.current && !viewMoreWrapperRef.current.contains(event.target)) {
    //             if(showViewMore){
    //                 setShowViewMore(false)
    //             }
    //         }        
    //     }
    // },[showViewMore])

    useEffect(()=>{
        document.addEventListener("mousedown", handleClickOutside);

        function handleClickOutside(event) {
            if (filterWrapperRef.current && !filterWrapperRef.current.contains(event.target)) {
                if(showFilter){
                    setShowFilter(false)
                }
            }
        
        }
    },[showFilter])


    return ( 
        <>
            <div className="git-leaks-main-content bg-white-with-shadow p-3 ">
                <div className="search-header-container d-flex align-items-center gap-3">
                    <div className="d-flex gap-3">
                        <div className="search-container position-relative" onKeyDown={handleSearchKeyDown}>
                            <span className="position-absolute">{searchIcon()}</span>
                            <input type="text" 
                                placeholder="Search" 
                                value={searchValue} 
                                onChange={(e)=>{
                                    setSearchValue(e.target.value)
                                }}
                                onFocus={() => setIsSearchFocused(true)}
                                onBlur={() => setIsSearchFocused(false)}
                            />
                        </div>
                        <button className="search-btn" onClick={onSearch}>Search</button>
                    </div>                    
                    <EndpointsFilter endPointFilterApply={endPointFilterApply} endpointFiltersValue={endpointFiltersValue} currentPage={"botnetLeaks"} />
                    {isAnyEndpointFilterActive && (<span className="reset-filter-link" onClick={resetEndpointFilterValue}>Reset Filter</span>)}
                </div>
                <div className="js-secrets-table ransomware-group-table mt-3">
                    {
                        isLoading ?
                        <SkeletonLoader type={"line"} count={5} currentPage={"gitleaks"} />
                        :
                        <Table responsive="lg">
                            <thead>
                                <tr>
                                    <th>Details</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    ransomwereGroupDataResponse?.results?.length > 0 &&
                                    ransomwereGroupDataResponse?.results?.map((data, index) => {
                                        return (
                                            <motion.tr
                                                key={index}
                                                initial={{ opacity: 0, y: 20 }}
                                                animate={{ opacity: 1, y: 0 }}
                                                transition={{ duration: 0.4, delay: index * 0.1 }}
                                            >
                                                <td className="leak-details">
                                                    <div className="d-flex justify-content-between">
                                                        <div>
                                                            {!data?.new_record && <p className="d-inline-block new-data my-2">New</p>}
                                                            <p className="heading-text mb-2">Group Name:</p>
                                                            <span className="details d-inline-block mb-3">{data?.group_name}</span> 

                                                            <p className="heading-text mb-2">Leak Title/Domain:</p>
                                                            <span className="details">{data?.leak_title}</span> - <span className="details">{data?.leak_domain}</span> {data?.leak_published ? <span className="published">Published</span> : <span className="published">DeadLine - {formatDate(data?.leak_deadline, "date")}</span>}

                                                            <p className="heading-text mb-2">Leak Date:</p>
                                                            <span className="details">{formatDate(data?.leak_date, "date")}</span>                                                                                        
                                                        </div>
                                                        <div className="screenshot-image">
                                                            <p className="overlay" onClick={()=>{
                                                                setScreenShotSrc(data?.leak_screenshot)
                                                                setShowScreenshotModal(true);
                                                            }}>
                                                                <span>{showScreenshotIcon()}</span>
                                                            </p>
                                                            <img src={data?.leak_screenshot} alt="screenshot" />
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <p className="heading-text my-2">Description:</p>
                                                        <span className="details">{data?.leak_description}</span>

                                                        <p className="heading-text my-2">Post Url</p>
                                                        <a className="text-overflow table-url" href={data?.leak_post_url} target="_blank"  rel="noreferrer">{data?.leak_post_url}</a>

                                                        <p className="heading-text my-2">Leak download Link</p>
                                                        <a className="text-overflow table-url" href={data?.leak_download_url} target="_blank"  rel="noreferrer">{data?.leak_download_url}</a>
                                                    </div> 
                                                </td>
                                            </motion.tr>
                                        )
                                    })
                                }
                            </tbody>
                        </Table>
                    }
                    {
                        !isLoading && scanNotFound && 
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.4 }}
                        >
                            <NoDataFound noDataText={ransomwereGroupDataResponse?.description} />
                        </motion.div>
                    }
                    {
                        !isLoading && !scanNotFound && ransomwereGroupDataResponse !== "" && ransomwereGroupDataResponse?.results?.length === 0 && 
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.4 }}
                        >
                            <NoDataFound noDataText={"No Record Found"}/>
                        </motion.div>
                    }
                    {ransomwereGroupDataResponse !== "" && ransomwereGroupDataResponse?.results?.length > 0 && <Pagination
                        className="pagination-bar"
                        currentPage={currentPage}
                        pageSize={currentPageSize}
                        totalCount={ransomwereGroupDataResponse?.meta?.total_results}
                        onPageChange={setCurrentPageandRecordSize}
                    />}
                    {
                        <Modal
                            show={showScreenshotModal}
                            onHide={()=>setShowScreenshotModal(false)}
                            size="lg"
                            centered
                            className=""
                            >
                                <Modal.Body>                                
                                    <div className="Screenshot-modal-container">
                                        <div className="p-4 m-2">
                                            <img src={screenShotSrc} alt="screenshot" />
                                        </div>
                                    </div>
                                </Modal.Body>
                        </Modal>
                    }           
                </div>
            </div>
        </>        
    )
}


export default ThirdPartyRansomewareGroupLeaks;